import { Field, FormTheme, Label } from '@kanda-libs/ks-component-ts';
import useAmountToBorrow from './useAmountToBorrow';

const AmountToBorrow: React.FunctionComponent = function ({}) {
  const { isLoading, validation } = useAmountToBorrow();
  return (
    <div className="flex flex-col">
      <Label label="Amount you want to borrow" />
      <FormTheme variant="emphasized">
        <Field.Validator validation={validation}>
          <Field.NumberInput
            name="amountToBorrow"
            label=""
            type="price"
            isLoading={isLoading}
          />
        </Field.Validator>
      </FormTheme>
    </div>
  );
};

export default AmountToBorrow;
